<template>
    <div class="text-center">
        <div class="flex justify-center mb-md">
            <img
                src="/img/bank-id.svg"
                alt="BankID"
                class="mb-md h-6xl"
            >
        </div>

        <div v-if="error">
            <div v-if="initialError">
                <p>{{ lang('Ett fel uppstod vid beställning', 'An error occurred while placing your order') }}.</p>
                <p>
                    <a :href="route('front.order.create')" class="btn btn-md is-ghost mr-lg">{{ lang('Gå tillbaka', 'Go back') }}</a>
                </p>
            </div>
            <div v-else>
                <p>{{ errorMessage || lang('Ett fel uppstod och legitimeringen kunde inte genomföras', 'An error occurred') }}.</p>
                <p>
                    <a :href="route('front.order.create')" class="btn btn-md is-ghost mr-lg mb-md md:mb-0">{{ lang('Avbryt', 'Abort') }}</a>
                    <a class="btn btn-md is-primary" @click="submit()">
                        {{ lang('Starta legitimering igen', 'Start identification again') }}
                    </a>
                </p>
            </div>
        </div>
        <div
            v-else-if="waitingForAuth"
            class="mt-lg mb-2xl p-md text-center"
        >
            <div v-if="bankIdAppUrl">
                <p>
                    <a :href="bankIdAppUrl" class="btn btn-lg is-primary">
                        {{ lang('Öppna BankID-appen och legitimera dig', 'Open the BankID app to identify your self') }}
                    </a>
                </p>
            </div>
            <div v-else class="mb-lg">
                <p>
                    {{
                        lang(
                            'Öppna BankID-appen på din mobil eller surfplatta och legitimera dig.',
                            'Open the BankID app on your cellphone or tablet to identify yourself'
                        )
                    }}
                </p>
            </div>

            <div v-if="qrCode && ! isMobileDevice">
                <!-- eslint-disable vue/no-v-html -->
                <span v-html="qrCode" />
            </div>

            <font-awesome-icon
                icon="spinner"
                spin
                pulse
                class="text-success"
                size="2x"
            />

            <div class="flex justify-center my-lg">
                <button
                    type="button"
                    class="block btn btn-md is-ghost"
                    @click="cancel()"
                >
                    {{ lang('Avbryt', 'Cancel') }}
                </button>
            </div>
        </div>
        <div v-else>
            <p>{{ lang('Startar legitimering med BankID', 'Starting BankID identification') }}...</p>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        initialError: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            error: this.initialError,
            errorMessage: '',
            waitingForAuth: false,
            bankIdAppUrl: null,
            loading: false,
            qrCode: null,
        };
    },
    computed: {
        isMobileDevice() {
            return utils.isMobileDevice();
        },
    },
    mounted() {
        if (! this.error) {
            this.submit();
        }
    },
    methods: {
        submit() {
            this.error = null;
            this.errorMessage = '';
            this.loading = true;

            axios.post(route('front.api.bank-id.init-auth'))
                .then((response) => {
                    if (utils.isDeviceSupportingBankId()) {
                        this.bankIdAppUrl = response.data.bankIdAppUrl;
                    }

                    this.qrCode = response.data.qrCode;

                    this.waitForAuth();
                })
                .catch(error => {
                    this.error = true;
                    this.errorMessage = error.response.data.message;
                })
                .then(() => {
                    this.loading = false;
                });
        },

        hide() {
            this.$emit('hide');
        },

        cancel() {
            this.waitingForAuth = false;
            this.error = true;

            axios.post(route('front.api.bank-id.cancel-auth'))
                .then((response) => {
                })
                .catch(error => {
                    this.error = true;
                    this.errorMessage = error.response.data.message;
                });
        },

        waitForAuth() {
            this.waitingForAuth = true;
            this.pollCount = 0;

            setTimeout(() => {
                this.pollForAuth();
            }, 1000);
        },

        pollForAuth() {
            if (! this.waitingForAuth) {
                return;
            }

            this.pollCount++;

            axios.get(route('front.api.bank-id.poll-for-order-auth'))
                .then((response) => {
                    if (response.data.success) {
                        window.location = route('front.order.storeFromBankIdAuth');
                    } else {
                        if (this.pollCount >= 40) {
                            this.waitingForAuth = false;
                            this.error = true;
                            this.errorMessage = lang('Inloggningen tog för lång tid. Försök igen.', 'It took too long to log in.');
                        } else {
                            this.qrCode = response.data.qrCode;

                            setTimeout(() => {
                                this.pollForAuth();
                            }, 2000);
                        }
                    }
                })
                .catch(error => {
                    this.waitingForAuth = false;
                    this.error = true;
                    this.errorMessage = error.response.data.message;
                });
        },
    },
};
</script>
